import { useAppTranslation } from '@/hooks/useAppTranslation';
import { Button } from '@components/Button/Button';
import { useRouter } from 'expo-router';
import type { ReactElement } from 'react';

export const SpeciesSearchBackAction = (): ReactElement => {
  const { t } = useAppTranslation();
  const router = useRouter();

  return (
    <Button
      variant="outlined"
      title={t('buttons.back')}
      onPress={() => router.back()}
    />
  );
};
